export default {
  getCashRegister(state) {
    return state.cashRegister;
  },
  getCashRegisters(state) {
    return state.cashRegisters;
  },
  getCashRegistersMap(state) {
    return state.cashRegisters?.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
  getCashRegisterStates(state) {
    return state.cashRegisterStates;
  },
  getCashRegisterOrders(state) {
    return state.orders;
  },
  getCashRegisterOrdersCanceled(state) {
    return state.ordersCanceled;
  },
  getCashRegisterReportProducts(state) {
    return state.reportProducts;
  },
  getCashRegisterReportTotals(state) {
    return state.reportTotals;
  },
  getCashRegisterReportClose(state) {
    return state.reportClose;
  },
  getCashRegisterPaymentMethods(state) {
    return state.paymentMethods;
  },
  getCashRegisterShift(state) {
    return state.shift;
  },
};
